import {
    GET_RULES_SUCCESS,
    GET_RULES_FAILURE,
    RulesActionTypes,
    rulesInit,
    GET_AIRLINES_LIST_SUCCESS,
    GET_AIRLINES_LIST_CLEAR,
} from './types';


export function rules(state = rulesInit, action: RulesActionTypes) {
    switch (action.type) {
        case GET_RULES_SUCCESS:
            return action.payload.data;
        case GET_RULES_FAILURE:
            return action.payload.data;
        default:
            return state;
    }
}

export function airlinesList(state = [], action: RulesActionTypes) {
    switch (action.type) {
        case GET_AIRLINES_LIST_SUCCESS:
            return action.payload.data;
        case GET_AIRLINES_LIST_CLEAR:
            return action.payload.data;
        default:
            return state;
    }
}